import { themes } from "prism-react-renderer";

export const codeTheme = themes.vsLight;
